import React, { useState } from 'react';
import {FiExternalLink, FiChevronUp} from "react-icons/fi";

const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  

export default function TransactionItem(props) {
    const [info, setInfo] = useState(false);
    const {item} = props;
    const receiptLink = () => { window.open(item.receipt_url, '_blank'); };
    const status = item.status;
    const re = /_/gi;
    const statusSpace = status.replace(re, ' ');
    const statusCapSpace = statusSpace[0].toUpperCase() + statusSpace.slice(1);
    const statusColor = (status === 'succeeded') ? 'var(--grn)' : (status === 'requires_payment_method') ? 'var(--org)' : 'var(--red)';
    const date = new Date(item.created * 1000);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hour = (date.getHours() < 10 && '0') + date.getHours();
    const minutes = (date.getMinutes() < 10 && '0') + date.getMinutes();
    const seconds = (date.getSeconds() < 10 && '0') + date.getSeconds();
    const time = hour + ':' + minutes + ':' + seconds;
    const fullDate = month + ' ' + day;
    const price = item.amount / 100;
    const priceCents = price.toFixed(2);
    const priceNoFee = priceCents / 1.05;
    const fee = priceNoFee / 20;
    const forr = item.for;
    return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <div className='TransactionItems'
            >
                <p style={{
                    color: statusColor,
                    fontSize: 16,
                    margin: 3,
                    cursor: 'pointer',
                    textAlign: 'center'
                }}
                onClick={() => {info ? setInfo(false) : setInfo(true);}}
                >
                {fullDate}
                </p>
                <p style={{
                    color: statusColor,
                    // width: '400px',
                    fontSize: 16,
                    margin: 3,
                    paddingInline: 20,
                    cursor: 'pointer',
                    textAlign: 'center'
                }}
                onClick={() => {info ? setInfo(false) : setInfo(true);}}>
                {forr}
                </p>
                <p style={{
                    color: statusColor,
                    fontSize: 16,
                    margin: 3,
                    cursor: 'pointer',
                    textAlign: 'center'
                }}
                onClick={() => {info ? setInfo(false) : setInfo(true);}}>
                $ {priceCents}
                </p>
            </div>
            { info &&
            <div style={{display:  'flex', flexDirection: 'column'}}>
                <p className='TransactionItemText'>
                Event name: {item.eventName}
                </p>
                <div style={{flexDirection: 'row'}}>
                <p className='TransactionItemText'>
                    From: {item.fromName}
                </p>
                <p className='TransactionItemText'>
                    To: {item.toName}
                </p>
                </div>
                <p className='TransactionItemText'>
                For: {forr}
                </p>
                <div style={{flexDirection: 'row'}}>
                <p className='TransactionItemText'>
                    Price: ${priceNoFee}
                </p>
                <p className='TransactionItemText'>
                    Fee: ${fee}
                </p>
                </div>
                <div style={{flexDirection: 'row'}}>
                <p className='TransactionItemText'>
                    Date: {fullDate}.{year}
                </p>
                <p className='TransactionItemText'>
                    Time: {time}
                </p>
                </div>
                <div style={{flexDirection:'row'}}>
                <p className='TransactionItemText' style={{marginEnd: 5}}>
                    Status:
                </p>
                <p className='TransactionItemText' style={{color: statusColor}}>
                    {statusCapSpace}
                </p>
                </div>
                {item.receipt_url &&
                <button
                style={{ marginHorizontal: 10, alignSelf: 'center', color: 'var(--wht)', borderWidth: 0}}
                onClick={receiptLink}>
                div receipt <FiExternalLink />
                </button>
                
                // <Btn title="div receipt"
                //     color={'var(--wht)'}
                //     style={{marginHorizontal: 10, alignSelf: 'center'}}
                //     size={15}
                //     icon={{ name: 'external-link', position: 'right' }}
                //     onClick={() => { Linking.openURL(item.receipt_url); }}
                // />
                }
                
                {/* <Btn icon={{ name:'chevron-up', position: 'right' }}
                    title={'collapse'}
                    style={{ alignSelf: 'center' }}
                    size={16}
                    color={'var(--ltg)'}
                    onClick={() => {setInfo(false)}}
                /> */}
                <button
                style={{ marginHorizontal: 10, alignSelf: 'center', color: 'var(--ltg)', borderWidth: 0}}
                onClick={() => {setInfo(false)}}>
                collapse <FiChevronUp />
                </button>
            </div>
            }
             <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
        </div>
    );
}
